import { gql } from 'graphql-request';

import { gqlClient } from 'graphql/gqlClient';
import { EventPublishSchedule } from 'types/event.types';

import { EventPublishScheduleFragment } from './common';

type ScheduleEventPublishResponse = {
  scheduleEventPublish: {
    ok: boolean;
    schedule: EventPublishSchedule;
  };
};

type RescheduleEventPublishResponse = {
  rescheduleEventPublish: {
    ok: boolean;
    schedule: EventPublishSchedule;
  };
};

type RemoveEventPublishScheduleResponse = {
  removeEventPublishSchedule: {
    ok: boolean;
  };
};

const SCHEDULE_EVENT_PUBLISH_MUTATION = gql`
  mutation ScheduleEventPublish($input: ScheduleEventPublishInput!) {
    scheduleEventPublish(input: $input) {
      ok
      schedule {
        ...EventPublishScheduleFragment
      }
    }
  }
  ${EventPublishScheduleFragment}
`;

const RESCHEDULE_EVENT_PUBLISH_MUTATION = gql`
  mutation RescheduleEventPublish($input: RescheduleEventPublishInput!) {
    rescheduleEventPublish(input: $input) {
      ok
      schedule {
        ...EventPublishScheduleFragment
      }
    }
  }
  ${EventPublishScheduleFragment}
`;

const REMOVE_EVENT_PUBLISH_SCHEDULE_MUTATION = gql`
  mutation RemoveEventPublishSchedule($input: RemoveEventPublishScheduleInput!) {
    removeEventPublishSchedule(input: $input) {
      ok
    }
  }
`;

const scheduledPublishApi = {
  schedule: async (
    eventId: number,
    scheduledAt: string,
    timezoneCode?: string
  ): Promise<ScheduleEventPublishResponse['scheduleEventPublish']> => {
    return gqlClient
      .request<ScheduleEventPublishResponse>(SCHEDULE_EVENT_PUBLISH_MUTATION, {
        input: { eventId, scheduledAt, timezoneCode }
      })
      .then((res) => res.scheduleEventPublish);
  },

  reschedule: async (
    eventId: number,
    scheduledAt: string,
    timezoneCode?: string
  ): Promise<RescheduleEventPublishResponse['rescheduleEventPublish']> => {
    return gqlClient
      .request<RescheduleEventPublishResponse>(RESCHEDULE_EVENT_PUBLISH_MUTATION, {
        input: { eventId, scheduledAt, timezoneCode }
      })
      .then((res) => res.rescheduleEventPublish);
  },

  remove: async (
    eventId: number
  ): Promise<RemoveEventPublishScheduleResponse['removeEventPublishSchedule']> => {
    return gqlClient
      .request<RemoveEventPublishScheduleResponse>(REMOVE_EVENT_PUBLISH_SCHEDULE_MUTATION, {
        input: { eventId }
      })
      .then((res) => res.removeEventPublishSchedule);
  }
};

export { scheduledPublishApi };
